import { render, staticRenderFns } from "./CYTMemorabilia.vue?vue&type=template&id=2adc5412&scoped=true"
import script from "./CYTMemorabilia.vue?vue&type=script&lang=js"
export * from "./CYTMemorabilia.vue?vue&type=script&lang=js"
import style0 from "./CYTMemorabilia.vue?vue&type=style&index=0&id=2adc5412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc5412",
  null
  
)

export default component.exports